import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import Utils from "../../../../utils/utils";
import {Month} from "../../student/attendance";
import {Week} from "../../../../components/Week";

class ModalCopyMenuWeek extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            price: 0,
            status: true,
            state: "ACTIVE"
        };
    }
    createBusType = () => {
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        if (this.state.name.length < 3){
            toast.error("Tên loại tuyến phải lớn hơn 3 ký tự", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else if (price < 1000){
            toast.error("Vui lòng nhập giá tuyến xe bus!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            let payload = {
                "name": this.state.name,
                "price": price,
                "state": this.state.status?"ACTIVE":"INACTIVE",
            }
            BusTypeController.create(payload, res => {
                if (res.success) {
                    toast.success("Thêm loại tuyến xe bus thành công!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                    this.props.onHide();
                    this.props.onRefresh()
                } else {
                    toast.error("Có lỗi xảy ra!", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 3000
                    });
                }
            })
        }
    }
    renderMonth() {
        return Month.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderWeek() {
        return Week.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Sao chép thực đơn tuần</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-12 label-item pl-0">Thông tin thực đơn <span  style={{color: "red",}}>Tuần 2 -Tháng 10/2023</span> sẽ được sao chép từ thông tin thực đơn:</label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-3 label-item pl-0">Tháng</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.state.state = e.target.value;
                                            this.setState({
                                                state: e.target.value
                                            })
                                        }}
                                    >
                                        {this.renderMonth()}
                                    </select>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-3 label-item pl-0">Tuần</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.state}
                                        onChange={(e) => {
                                            this.state.state = e.target.value;
                                            this.setState({
                                                state: e.target.value
                                            })
                                        }}
                                    >
                                        {this.renderWeek()}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createBusType()}
                                >
                                        <span className='justify-content-center'>
                                            Sao chép
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalCopyMenuWeek